export enum Framework {
    Analog = 'analog',
    Angular = 'angular',
    Nextjs = 'nextjs',
    React = 'react',
    Nuxt = 'nuxt',
    Vue = 'vue',
    Sveltekit = 'sveltekit',
    Astro = 'astro',
    Tanstackstart = 'tanstack-start',
    Remix = 'remix',
    Lynx = 'lynx',
    Flutter = 'flutter',
    Reactnative = 'react-native',
    Vite = 'vite',
    Other = 'other',
}